import React, { Component } from "react";
import Cookies from "js-cookie";
import { Layout, Dropdown, Avatar, Menu, notification } from "antd";
import Logo from "../logo";
import UIMenu from "../menu";
import MenuItem from "../../models/menuItem";
import Notice from "../notice";
import HeadSearch from "../search";
import calcelImg from "../../../assets/images/calcel.svg";
import AppService from "../app.service";
import User from "../user";
// model
import MessageDetails from "../notice/model/messageDetails";
import TodoDetails from "../notice/model/todoDetails";

import DefaultHeadImg from "@/assets/image/head/defaultHead.svg";
import { url } from "inspector";
import { cursorTo } from "readline";

const { Header } = Layout;
interface iProps {
  menuItems: MenuItem[];
  avatar: string;
  userName: string;
  fullName: string;
  name: string;
  schoolName: string;
  appName: string;
  logo: string;
  hasSearchBar: boolean;
  mode?: string;
  hiddenLogout?: boolean;
  showBackToOther?: boolean;
}
interface iState {
  noticeMsg: any;
  noticeCurrentTab: string;
  noticeList: any[];
  messageList: MessageDetails[];
  todoList: TodoDetails[];
}
export default class UIHeader extends Component<iProps, iState> {
  private appService: AppService = new AppService();
  state: iState = {
    noticeMsg: {},
    noticeCurrentTab: "1",
    noticeList: [],
    messageList: [],
    todoList: [],
  };
  // 退出登录
  exitSystem = async () => {
    let data = await this.appService.doLogout(Cookies.get("token"));
    if (data === "ok") {
      notification["success"]({
        message: "退出成功，即将跳转",
        duration: 1,
      });
      Cookies.set("token", "");
      Cookies.set("tenantId", "");
      window.location.href =
        window.location.origin + "/fe-pc/fe_newlogin/login";
    }
  };
  getMenu = (flag) => {
    let menu = !flag ? (
      <Menu>
        <Menu.Item
          key="0"
          onClick={() => {
            window.location.href =
              window.location.origin + "/fe-pc/b/bx_system_personal";
          }}
        >
          个人中心
        </Menu.Item>

        <Menu.Divider />
        <Menu.Item key="3" onClick={this.exitSystem}>
          退出登录
        </Menu.Item>
      </Menu>
    ) : (
      <Menu>
        <Menu.Item
          key="0"
          onClick={() => {
            window.location.href =
              window.location.origin + "/fe-pc/b/bx_system_personal";
          }}
        >
          个人中心
        </Menu.Item>
      </Menu>
    );
    return menu;
  };

  getNoticeList = async () => {
    let noticeList = await this.appService.getTopMsgNumber();
    let noticeMsg: any = {};
    noticeList &&
      noticeList.length &&
      noticeList.map((item) => {
        noticeMsg[item.key] = item.value;
      });
    this.setState({ noticeMsg });
  };
  gotoHome = () => {
    try {
      window.location.replace(localStorage.getItem("from"));
    } catch (err) {
      notification["warning"]({
        message: "获取主页路径失败，请联系管理员～",
      });
    }
  };
  // 获取未读通知
  getTopUnReadNotice = async () => {
    let noticeList = await this.appService.getTopUnReadNotice();
    this.setState({ noticeList });
  };
  // 获取未读消息
  getTopUnReadMessage = async () => {
    let messageList = await this.appService.getTopUnReadMessage();
    this.setState({ messageList });
  };
  // 获取未读todo
  getTopUnReadTodo = async () => {
    let todoList = await this.appService.getTopUnReadTodo();
    this.setState({ todoList });
  };
  changeNoticeTab = async (noticeCurrentTab) => {
    await this.setState({ noticeCurrentTab });
    this.getNumber();
  };
  getNumber = () => {
    this.state.noticeCurrentTab &&
      this.state.noticeCurrentTab === "1" &&
      this.getTopUnReadNotice();
    this.state.noticeCurrentTab &&
      this.state.noticeCurrentTab === "2" &&
      this.getTopUnReadMessage();
    this.state.noticeCurrentTab &&
      this.state.noticeCurrentTab === "3" &&
      this.getTopUnReadTodo();
  };
  // 全部标记已读消息
  checkAllMessage = async () => {
    const that = this;
    let data = await this.appService.markAllReadMessage();
    if (data) {
      notification["success"]({
        message: "已全部标记为已读",
        duration: 1,
        onClose() {
          that.getNoticeList();
          that.getNumber();
        },
      });
    }
  };

  // 重新获取三个
  componentDidMount() {
    this.getNoticeList();
  }
  render() {
    let {
      menuItems,
      name,
      avatar,
      userName,
      fullName,
      schoolName,
      logo,
      appName,
      hasSearchBar,
      mode = "dark",
      showBackToOther,
    } = this.props;
    console.log(showBackToOther, 5646);
    let { noticeMsg = {}, noticeList, messageList, todoList } = this.state;
    return (
      <Header
        style={{
          height: 48,
          lineHeight: "48px",
          position: "fixed",
          zIndex: 999,
          width: "100%",
          backgroundColor: mode === "dark" ? "#001529" : "#fff",
          display: "flex",
          alignItems: "center",
          boxShadow: "0px 1px 4px 0px rgba(0,21,41,0.12)",
          paddingLeft: "20px",
          padding: "0 24px",
        }}
      >
        <Logo mode={mode} logo={logo} name={name} schoolName={schoolName} />
        {/* 导航 */}
        <UIMenu mode={mode} appName={appName} menuItems={menuItems}></UIMenu>
        <div style={{ display: "flex", alignItems: "center" }}>
          {/* 查询框 */}
          {hasSearchBar && <HeadSearch mode={mode}></HeadSearch>}
          {/* 通知 */}
          <Notice
            noticeMsg={noticeMsg}
            changeNoticeTab={this.changeNoticeTab}
            getNumber={this.getNumber}
            getNoticeList={this.getNoticeList}
            noticeList={noticeList}
            messageList={messageList}
            todoList={todoList}
            checkAllMessage={this.checkAllMessage}
            mode={mode}
          ></Notice>
          {showBackToOther && (
            <div
              className="returnBtn"
              onClick={() => this.gotoHome()}
              style={{
                width: "104px",
                height: "32px",
                background: "#334454",
                color: "#FFF",
                textAlign: "center",
                fontFamily: "Microsoft YaHei UI",
                fontSize: "12px",
                fontStyle: "normal",
                fontWeight: 400,
                lineHeight: "18px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                cursor: "pointer",
              }}
            >
              <img
                src={calcelImg}
                className="returnBtnImg"
                style={{
                  width: "16px",
                  height: "16px",
                  marginRight: "4px",
                }}
              ></img>
              返回主页面
            </div>
          )}
          {/* 头像及下拉菜单 */}
          <Dropdown
            overlay={this.getMenu(this.props.hiddenLogout)}
            className="head_drop"
          >
            <div
              style={{ paddingLeft: 10, display: "flex", alignItems: "center" }}
            >
              <Avatar src={avatar || DefaultHeadImg} />
              <div
                style={{
                  color: mode === "dark" ? "#fff" : "#333",
                  marginLeft: 8,
                  width: 60,
                  lineHeight: "16px",
                }}
              >
                {fullName}
              </div>
            </div>
          </Dropdown>
        </div>
      </Header>
    );
  }
}
